import {Injectable} from '@angular/core';
import * as NavigationsActions from './navigations.actions';
import {map, switchMap, take} from 'rxjs/operators';
import {NavigationsPartialState} from './navigations.reducer';
import {Actions, createEffect} from '@ngrx/effects';
import {DataPersistence, withCorrelationIdOf} from '@kion/ngrx-helper';
import {Navigation} from '@kion/data-models';
import {ActionCache} from '../../../../../helper/ngrx-helper/src/lib/action-cache';
import {NavigationsQuery} from './navigations.selectors';
import {of} from 'rxjs';
import {NavigationConnectors} from "./navigation.connectors";

@Injectable()
export class NavigationsEffects {
  loadAll$ = createEffect(() =>
    this.dataPersistence.fetch(
      NavigationsActions.loadAll,
      {
        run: (
          action: ReturnType<typeof NavigationsActions.loadAll>
        ) => {
          return this.dataPersistence.store.select(NavigationsQuery.getAllNavigations).pipe(
            take(1),
            switchMap(
              (navigation: Navigation[]) => {
                const runAction = this.backend.getAll().pipe(
                  map(
                    (navigations: Navigation[]) => withCorrelationIdOf(
                      action,
                      NavigationsActions.loadAllSuccess({navigations: navigations})
                    )
                  )
                );
                if (navigation.length > 0) {
                  return this.actionCache.withCache(
                    action,
                    () => runAction,
                    () => of(
                      withCorrelationIdOf(
                        action,
                        NavigationsActions.loadAllSuccess({navigations: navigation})
                      )
                    )
                  )
                }
                return runAction;
              }
            )
          )
        },
        onError: (
          action: ReturnType<typeof NavigationsActions.loadAll>,
          error
        ) => {
          console.error('Error', error);
          return withCorrelationIdOf(
            action,
            NavigationsActions.loadAllError({error: error})
          );
        }
      }
    )
  );

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<NavigationsPartialState>,
    private backend: NavigationConnectors,
    private actionCache: ActionCache
  ) {
  }
}

